import * as React from 'react';
import * as classes from '@common/components/card/card.scss';

export const CardHeader = (props: any) => (
  <div className={`${classes.cardHeader}`}>
    {props.isExpanded}
    {props.isExpanded ? (
      <i
        onClick={props.toggleHeight}
        className={[
          'fas fa-2x',
          props.isTab ? classes.leftCardIcon : classes.cardIcon,
          props.iconClassName ? props.iconClassName : '',
          props.zip ? 'fa-minus-circle' : 'fa-caret-down'
        ].join(' ')}
      />
    ) : (
      <i
        onClick={props.toggleHeight}
        className={[
          'fas fa-2x',
          props.isTab ? classes.leftCardIcon : classes.cardIcon,
          props.iconClassName ? props.iconClassName : '',
          props.zip ? 'fa-plus-circle' : 'fa-caret-up'
        ].join(' ')}
      />
    )}
    {props.children}
  </div>
);

export const CardBody = (props: any) => (
  <div className={classes.bodyBorder}>
    <div className={props.isExpanded ? classes.cardBody : [classes.cardBody, classes.shrunk].join(' ')}>
      <div className={'col-xs-12 ' + props.className}>{props.children}</div>
    </div>
  </div>
);

interface CardProperties {
  children: any;
  defaultClosed?: boolean;
  hasError?: boolean;
  zip?: boolean;
  active?: boolean;
}

interface CardState {
  isExpanded: boolean;
}

export class Card extends React.Component<CardProperties, CardState> {
  state = {
    isExpanded: !this.props.defaultClosed
  };

  // Commented out because its causing display issues on children components
  // TODO Refactor CardHeader to be a prop so we can detect changes in it here
  // shouldComponentUpdate(newProps: CardProperties, newState: CardState) {
  //   if (this.props.zip) {
  //     return true;
  //   }
  //   const shouldUpdate =
  //     (newProps !== this.props && newState.isExpanded) || this.state.isExpanded !== newState.isExpanded;
  //   return shouldUpdate;
  // }

  toggleHeight = () => {
    this.setState(prevState => {
      return {
        isExpanded: !prevState.isExpanded
      };
    });
  };

  render() {
    let childrenWithProp = this.props.children.map((child: any, index: number) =>
      React.cloneElement(child, {
        key: index,
        isExpanded: this.state.isExpanded || this.props.hasError,
        toggleHeight: this.toggleHeight,
        hasError: this.props.hasError,
        zip: this.props.zip
      })
    ); // React.cloneElement(this.props.children, { toggleHeight: this.toggleHeight });
    return (
      <div
        className={`${classes.card}${this.props.zip ? ' ' + classes.zip : ''}${
          this.props.active ? ' ' + classes.active : ''
        }`}
      >
        {childrenWithProp}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/card/card.component.tsx